import { h, VNode, FunctionComponent, toChildArray } from "preact"; /** @jsx h */


import { Stacked, IStackedProps } from './Stacked';
import { Section, ISectionProps } from './Section';
import { Column, IColumnProps } from "./Column";
import { FixedColumn, IFixedColumnProps } from "./FixedColumn";
import { Fixed, IFixedProps } from "./Fixed";

export type ILayout = {
    Stacked: FunctionComponent<IStackedProps>;
    Section: FunctionComponent<ISectionProps>;
	Column: FunctionComponent<IColumnProps>;
    FixedColumn: FunctionComponent<IFixedColumnProps>;
    Fixed: FunctionComponent<IFixedProps>;
}

export const Layout: ILayout = {
    Stacked,
    Section,
    Column,
    FixedColumn,
    Fixed,
};






